import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { api } from "@/lib/api";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";

export function NotificationsBell() {
  const [data, setData] = useState({ count: 0, items: [] });
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const load = useCallback(async () => {
    try { const r = await api.get("/notifications"); setData(r.data); } catch {}
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [load]);

  const go = (orderId) => { setOpen(false); navigate(`/orders/${orderId}`); setTimeout(load, 600); };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button className="relative w-9 h-9 rounded-md flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors" data-testid="notifications-bell" aria-label="Customer questions">
          <Bell className="w-4 h-4" />
          {data.count > 0 && (
            <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-ruby text-white text-[10px] font-bold flex items-center justify-center" data-testid="notifications-count">
              {data.count}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0 bg-card border-border">
        <div className="px-4 py-3 border-b border-border">
          <span className="font-heading font-semibold text-sm">Customer questions</span>
        </div>
        <div className="max-h-80 overflow-y-auto" data-testid="notifications-list">
          {data.items.length === 0 ? (
            <p className="text-sm text-muted-foreground px-4 py-6 text-center">No new questions.</p>
          ) : (
            data.items.map((n) => (
              <button key={n.order_id} onClick={() => go(n.order_id)} data-testid={`notification-${n.order_id}`}
                className="w-full text-left px-4 py-3 border-b border-border last:border-0 hover:bg-secondary transition-colors">
                <div className="flex items-center justify-between gap-2">
                  <span className="mono font-semibold text-sm">{n.order_number}</span>
                  <span className="text-[11px] text-muted-foreground truncate">{n.customer_name}</span>
                </div>
                <p className="text-xs text-muted-foreground mt-1 line-clamp-2">{n.message}</p>
              </button>
            ))
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
